import { css } from 'styled-components';
import _ from 'lodash';

export const sizes = {
  desktop: 768,
  // xsScreen: 300,
};

export const sizesInEm = _.mapValues(sizes, (v) => `${v / 16}em`);

export const isDesktop = `
  (min-aspect-ratio: 13/9) and (min-width: 600px), (min-width: ${sizesInEm.desktop})
`;

// export const isXSmallScreen = `
//   min-width: 300px
// `

export const media = {
  desktop: (...args) => css`
    @media ${isDesktop} {
      ${css(...args)}
    }
  `,
  desktopOrPrint: (...args) => css`
    @media ${isDesktop}, print {
      ${css(...args)}
    }
  `,
  // xsScreen: (...args) => css`
  //   @media ${isXSmallScreen} {
  //     ${css(...args)}
  //   }  
  // `
};
